export const noScrollEnabled = (enabled: boolean) => {
  document.documentElement.style.overflow = enabled ? 'hidden' : 'initial'
}
